import React from 'react';

/**
 * Header — sticky site header with XMPie logo and navigation links.
 *
 * Links open in new tabs and point to the public XMPie website
 * (Help Center, Support, About).
 */
export default function Header() {
  return (
    <header className="site-header">
      <div className="header-inner">
        <div className="header-logo">
          <a href="https://www.xmpie.com" target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/images/xmpie-logo.svg`}
              alt="XMPie"
              className="logo-img"
            />
          </a>
        </div>
        <nav className="header-nav">
          <a href="https://help.xmpie.com/" target="_blank" rel="noopener noreferrer">Help Center</a>
          <a href="https://www.xmpie.com/support/contact-our-support-team/" target="_blank" rel="noopener noreferrer">Support</a>
          <a href="https://www.xmpie.com/about-xmpie/company/" target="_blank" rel="noopener noreferrer">About</a>
        </nav>
      </div>
    </header>
  );
}
